<template>
  <div 
    v-if="selected"
    class="video-preview clickable"
    @click="callVideo(selected.orderNumber)"
  >
    <img
      :src="selected.thumb"
      class="preview-thumb"
      crossOrigin="anonymous"
    >
    <div class="preview-title">
      {{ selected.previewTitle}}
    </div>
    <div class="play-button">
      <img
        src="/img/play.svg"
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'preview',
  props: {
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
        videos: 'getVideosData',
        // marked: 'getMarkedVideo',
        selected: 'getSelectedVideo'
    }),
    markedVideoThumb () {
      const thumb = this.marked
        ? this.videos.find(v => v.orderNumber === this.marked).thumb
        : undefined
      return thumb
    }

  },
  methods: {
    ...mapActions({
        toggleModal: 'toggleModal'
    }),
    callVideo(nr) {
      this.$router.push(`/video/${nr}`)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/scss/custom.scss';
.video-preview {
    width: 46%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 800;
    @media (max-width: $tabletL) {
      position: relative;
      margin-top: 2rem;
      width: 100%;
    }
    .preview-thumb {
      display: block;
      max-width: 100%;
    }
    .preview-title {
      padding: .4rem .8rem; 
      background-color: $red-light;
      color: $sand-light;
      font-size: $font-text-md;
      font-family: 'Titillium Web';
      font-weight: 400;
    }
    .play-button {
      position: absolute;
      top: calc(50% - 3.6rem);
      left: 0;
      width: 100%;
      img {
        display: block;
        width: 6rem;
        margin: 0 auto;
      }
    }
}
    
</style>
